import { proxy } from "valtio";
import { Contract } from "@models/contract.model";
import { SpendAccount } from "@models/spendaccount.model";
import { Credit } from "@models/credit.model";
import { Debit } from "@models/debit.model";
import { EngagementContractDetail } from "src/shared/services/engagements/contracts/commands/cmdGetEngagementContract.ts";

interface EngagementContractState {
  engagementId: number | null;
  availableContracts: Contract[];
  assignedDetail: EngagementContractDetail | null;
  selectedContractId: number | null;
  spendAccount: SpendAccount | null;
  credits: Credit[];
  debits: Debit[];
  balance: number | null;
  isLoading: boolean;
  isSaving: boolean;
  error: string | null;
}

export const engagementContractStore = proxy<EngagementContractState>({
  engagementId: null,
  availableContracts: [],
  assignedDetail: null,
  selectedContractId: null,
  spendAccount: null,
  credits: [],
  debits: [],
  balance: null,
  isLoading: false,
  isSaving: false,
  error: null,
});

export function resetEngagementContractStore() {
  engagementContractStore.engagementId = null;
  engagementContractStore.availableContracts = [];
  engagementContractStore.assignedDetail = null;
  engagementContractStore.selectedContractId = null;
  engagementContractStore.spendAccount = null;
  engagementContractStore.credits = [];
  engagementContractStore.debits = [];
  engagementContractStore.balance = null;
  engagementContractStore.isLoading = false;
  engagementContractStore.isSaving = false;
  engagementContractStore.error = null;
}